/* eslint-disable no-lone-blocks */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ColorWrapper from '@styles/colors';
import Loading from '@components/loading';
import { InteractionStatus } from '@azure/msal-browser';
import { getSecureValue, navigateTo } from '@helpers';
import { unlogin } from '@reducers/utils';
import { msalInstance, MSAL_SCOPES } from '@config/msalConfig';
import AccountChooser from './AccountChooser';

const ManualLogin = ({ updateTokenState, unlogin, useMsal }) => {
  const { instance, inProgress, accounts } = useMsal();
  const [showChooser, setShowChooser] = useState(false);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      // Check per-tab sessionStorage (not MSAL's shared cache) to decide
      // whether this tab already has an active session.
      const token = getSecureValue('token');
      if (token) {
        updateTokenState(token);
        const lastURL = getSecureValue('lastURL');
        if (lastURL) {
          try {
            const obj = JSON.parse(lastURL);
            if (obj.name) {
              return navigateTo(obj.name, obj.params);
            }
          } catch (e) {
            console.log(e, 'error parse last url');
          }
        }
        return navigateTo('Authorized');
      }

      // If MSAL has cached accounts from other sessions, show the account
      // chooser so the user can switch with one tap instead of re-entering credentials via B2C.
      const cachedAccounts = msalInstance.getAllAccounts();
      if (cachedAccounts.length > 0) {
        setShowChooser(true);
        return;
      }

      // No cached accounts — redirect to B2C login page.
      // prompt: 'login' forces B2C to show the credential form even if
      // there is an existing SSO session for another account.
      instance.loginRedirect({ scopes: MSAL_SCOPES, prompt: 'login' });
    }
  }, [instance, accounts, inProgress]);

  if (showChooser) {
    return <AccountChooser updateTokenState={updateTokenState} />;
  }

  return <Loading />;
};

export default connect(null, { unlogin })(ColorWrapper(ManualLogin));
